export default {"src":"/_next/static/media/YGGJ2.1619ffe2.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};